import React, { useState } from 'react'
import { FilterType, NodeFilterType, TreeFilterType } from './types'
import { Box, Button, Checkbox } from '@mui/material'
import { TypeSelect } from './TypeSelect'
import { BodyFilter } from './BodyFilter'

export function DescendantFilter({
  filter,
  onFiltersChanged,
}: {
  filter: TreeFilterType
  onFiltersChanged(filters: TreeFilterType): void
}) {
  return (
    <Box>
      <Adding filter={filter} onFiltersChanged={onFiltersChanged} />
    </Box>
  )
}

function Adding({
  filter,
  onFiltersChanged,
}: {
  filter: TreeFilterType
  onFiltersChanged(filters: TreeFilterType): void
}) {
  const [adding, setAdding] = useState(false)

  const descendantFilter = filter.descendantOf?.filter ?? {
    filterType: FilterType.node,
  }

  const onDescendantFilterChange = (descendantFilter: NodeFilterType) => {
    onFiltersChanged({
      ...filter,
      descendantOf: {
        directDescendant: filter.descendantOf?.directDescendant,
        filter: descendantFilter,
      },
    })
  }

  const onDirectChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    onFiltersChanged({
      ...filter,
      descendantOf: {
        directDescendant: checked,
        filter: descendantFilter,
      },
    })
  }

  if (adding) {
    return (
      <Box padding="20px" borderRadius="5px" border="1px solid">
        <Box>
          Adding Descendant Filter{' '}
          <Button onClick={() => setAdding(false)}>Cancel</Button>
        </Box>
        <Box>
          Direct Descendant:{' '}
          <Checkbox
            checked={!!filter.descendantOf?.directDescendant}
            onChange={onDirectChange}
          />
        </Box>
        <Box>
          <TypeSelect
            filter={descendantFilter}
            onFiltersChanged={onDescendantFilterChange}
          />
          <BodyFilter
            filter={descendantFilter}
            onFiltersChanged={onDescendantFilterChange}
          />
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      <Box>
        <Button onClick={() => setAdding(true)}>Add Descendant Filter</Button>
      </Box>
    </Box>
  )
}
